import { TABLE_CELL_TYPE } from 'types/enums.ts';
import type { DataSchema } from 'types';

export const heliosTemplatesDataScheme = {
  number: {
    label: 'number',
    type: TABLE_CELL_TYPE.NUMBER,
    translationKey: 'table.header.id',
  },
  name: {
    label: 'name',
    type: TABLE_CELL_TYPE.TEXT,
    translationKey: 'table.header.name',
  },
  moduleName: {
    label: 'moduleName',
    type: TABLE_CELL_TYPE.TEXT,
    translationKey: 'table.header.module',
  },
  status: {
    label: 'status',
    type: TABLE_CELL_TYPE.STATUS,
    translationKey: 'table.header.status',
  },
  templateType: {
    label: 'type',
    type: TABLE_CELL_TYPE.TEXT,
    translationKey: 'table.header.type',
  },
  modifiedDateTime: {
    label: 'modifiedDateTime',
    type: TABLE_CELL_TYPE.DATE,
    translationKey: 'table.header.updated',
  },
  datasourceName: {
    label: 'datasourceName',
    type: TABLE_CELL_TYPE.TEXT,
    translationKey: 'table.header.dataSource',
  },
  assignedRoles: {
    label: 'assignedRoles',
    type: TABLE_CELL_TYPE.NAME_ARRAY,
    translationKey: 'table.header.assignedRoles',
  },
  id: {
    label: 'id',
    type: TABLE_CELL_TYPE.ID,
    translationKey: 'table.header.id',
    hidden: true,
  },
  childrenTemplates: {
    label: 'childrenTemplates',
    type: TABLE_CELL_TYPE.TEXT,
    translationKey: 'childrenTemplates',
    hidden: true,
  },
} satisfies DataSchema;

export const heliosTemplateUserDefinedSchema = {
  id: {
    label: 'id',
    type: TABLE_CELL_TYPE.ID,
    translationKey: 'table.header.id',
  },
  name: {
    label: 'name',
    type: TABLE_CELL_TYPE.TEXT,
    translationKey: 'table.header.name',
  },
  type: {
    label: 'type',
    type: TABLE_CELL_TYPE.TEXT,
    translationKey: 'table.header.type',
  },
} satisfies DataSchema;

export const heliosTemplateAggregationGroupsSchema = {
  id: {
    label: 'id',
    type: TABLE_CELL_TYPE.ID,
    translationKey: 'table.header.id',
  },
  name: {
    label: 'name',
    type: TABLE_CELL_TYPE.TEXT,
    translationKey: 'table.header.name',
  },
  type: {
    label: 'type',
    type: TABLE_CELL_TYPE.TEXT,
    translationKey: 'table.header.type',
  },
  attributes: {
    label: 'attributes',
    type: TABLE_CELL_TYPE.TEXT,
    translationKey: 'table.header.attributes',
    hidden: true,
  },
};

export const heliosTemplateAggregationGroupInnerSchema = {
  id: {
    label: 'id',
    type: TABLE_CELL_TYPE.ID,
    translationKey: 'table.header.id',
  },
  type: {
    label: 'type',
    type: TABLE_CELL_TYPE.TEXT,
    translationKey: 'table.header.type',
  },
  value: {
    label: 'value',
    type: TABLE_CELL_TYPE.TEXT,
    translationKey: 'table.header.value',
  },
} satisfies DataSchema;

export const heliosTemplateFunctionsSchema = {
  id: {
    label: 'id',
    type: TABLE_CELL_TYPE.ID,
    translationKey: 'table.header.id',
  },
  alias: {
    label: 'alias',
    type: TABLE_CELL_TYPE.TEXT,
    translationKey: 'table.header.alias',
  },
  iconName: {
    label: 'icon',
    type: TABLE_CELL_TYPE.ICON,
    translationKey: 'table.header.icon',
  },
} satisfies DataSchema;

export const heliosTemplateRolesSchema = {
  roleId: {
    label: 'id',
    type: TABLE_CELL_TYPE.ID,
    translationKey: 'table.header.id',
  },
  roleName: {
    label: 'roleName',
    type: TABLE_CELL_TYPE.TEXT,
    translationKey: 'table.header.roleName',
  },
  create: {
    label: 'create',
    type: TABLE_CELL_TYPE.DATE,
    translationKey: 'table.header.dateOfChange',
  },
};

export const heliosTemplatePrintConfigurationsSchema = {
  id: {
    label: 'id',
    type: TABLE_CELL_TYPE.ID,
    translationKey: 'table.header.id',
  },
  name: {
    label: 'name',
    type: TABLE_CELL_TYPE.TEXT,
    translationKey: 'helios.templates.printConfigurations.name',
  },
  reportId: {
    label: 'reportId',
    type: TABLE_CELL_TYPE.NUMBER,
    translationKey: 'helios.templates.printConfigurations.reportId',
  },
  isActive: {
    label: 'isActive',
    type: TABLE_CELL_TYPE.SWITCH,
    translationKey: 'helios.templates.printConfigurations.active',
  },
} satisfies DataSchema;
